import * as React from "react";
import { forwardRef } from "react";
const SvgToolCobbAngle = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" strokeLinejoin="round" strokeWidth={1.5} transform="translate(1 1)"><path d="M4 10L16.5 3.5" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /><path d="M4 13L16.5 19.5" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /><path d="M10 7C12.9809 10.9506 12.7578 13.1369 10 17" stroke="#CCCCCC" strokeWidth={2} /></g></svg>;
const ForwardRef = forwardRef(SvgToolCobbAngle);
export { ForwardRef as ReactComponent };